import React from "react";
import { Routes, Route } from 'react-router-dom';
import AppHeader from "./app-header/app-header";
import Home from '../pages/home/home';
import Map from '../pages/map/map';

export default function App() {
    return (<>
            <AppHeader/>
            <Routes> {/* The Switch decides which component to show based on the current URL.*/}
                <Route path="/" element={<Home />} />
                <Route path="/map" element={<Map />} />
                {/* <Route exact path='/signup' component={Signup}></Route> */}
            </Routes>
            </>
    );
}